import { useState, useCallback } from 'react';
import { copyToClipboard } from '../utils';

export const useCopyToClipboard = () => {
  const [copiedTarget, setCopiedTarget] = useState<string | null>(null);

  const handleCopy = useCallback(async (text: string, target: string) => {
    const success = await copyToClipboard(text);
    if (success) {
      setCopiedTarget(target);
      setTimeout(() => setCopiedTarget(null), 2000);
    }
  }, []);

  return { copiedTarget, handleCopy };
};
